import { render, staticRenderFns } from "./transform-all.vue?vue&type=template&id=f9dd08e2&scoped=true&"
import script from "./transform-all.vue?vue&type=script&lang=js&"
export * from "./transform-all.vue?vue&type=script&lang=js&"
import style0 from "./transform-all.vue?vue&type=style&index=0&id=f9dd08e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dd08e2",
  null
  
)

export default component.exports